import data from "../../../../../src/Box/Box.docs.json";
import * as React from 'react';
export default {
  data,
  React
};